/**
 * Deals Entity Configuration
 */

import { useDeals, useDeal } from "../../../hooks/useApi";

const DealsConfig = {
  entity: "deals",
  entitySingular: "Deal",
  entityPlural: "Deals",

  hooks: {
    useEntities: useDeals,
    useEntity: useDeal,
  },

  routes: {
    list: "/deals",
    detail: "/deal/:id",
    new: "/new-deal",
    edit: "/deal/:id/edit",
  },

  statusOptions: [
    { value: "draft", label: "Draft", color: "gray" },
    { value: "active", label: "Active", color: "green" },
    { value: "completed", label: "Completed", color: "blue" },
    { value: "cancelled", label: "Cancelled", color: "red" },
  ],

  filterFields: ["status", "deal_type", "stage"],
  searchFields: ["deal_name", "description", "counterparty"],

  primaryField: "deal_name",
  secondaryField: "description",

  categoryIcons: {
    acquisition: "shopping-cart",
    disposal: "trending-up",
    development: "hammer",
    refinancing: "refresh",
    "joint-venture": "users",
  },

  defaultLayout: "cards",

  emptyState: {
    title: "No deals found",
    description: "Start by creating your first deal",
    actionText: "Create New Deal",
    actionRoute: "/new-deal",
  },

  features: {
    hasCategories: true,
    hasStatusBadges: true,
    hasProgressIndicators: true,
    hasQuickActions: true,
    supportsBulkActions: false,
  },
};

export default DealsConfig;
